import { DEFAULT_OTC_TABS } from '../../../Blotters/OTC/OTCDerivatives/defaults';
import type { OTCTabProps } from '../../../Blotters/OTC/OTCDerivatives/OTCDerivatives';
import { MobileBlotterPanel, type MobileBlotterPanelProps } from './MobileBlotterPanel';

/** Placeholder-only mobile OTC derivatives content; uses `TradingPlaceholder` via `MobileBlotterPanel`. */
export function MobileOTCDerivativesBlotter(props: Omit<MobileBlotterPanelProps<OTCTabProps>, 'defaultTabs'>) {
  return <MobileBlotterPanel<OTCTabProps> {...props} defaultTabs={DEFAULT_OTC_TABS} />;
}
